import React from 'react'
import FormUpdate from './FormUpdate'

const EditDeviceProfile = (props) => {
    return <FormUpdate isEdit {...props} />
}

export default EditDeviceProfile;